import { render, staticRenderFns } from "./AccessWalletKeystore.vue?vue&type=template&id=4bb3ee35"
import script from "./AccessWalletKeystore.vue?vue&type=script&lang=js"
export * from "./AccessWalletKeystore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports